import { jsxs as i, jsx as a } from "react/jsx-runtime";
import T, { useState as c, useEffect as _ } from "react";
import { a as A } from "../chunks/breakpoints.907eaecd.js";
import { _ as z, a as S, b as M, h as $, i as j } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { styled as t, css as e } from "styled-components";
import { a as m, R as B } from "../chunks/index.cff5baaf.js";
const E = t.div.withConfig({
  displayName: "RangoInputTextArea",
  componentId: "sc-1c1mphi-0"
})(["*{margin:0;padding:0;}width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:var(--spacing-1x);", " ", ""], A.md(e`
    min-width: 312px;
  `), ({
  disabled: o
}) => o && e`
      opacity: var(--disabled-opacity);
      pointer-events: none;
    `), L = t.label.withConfig({
  displayName: "Label",
  componentId: "sc-1c1mphi-1"
})(["", " color:var(--text-label-color);", " ", " ", ""], z, ({
  clicked: o
}) => o && e`
      color: var(--active-label-color);
    `, ({
  disabled: o
}) => o && e`
      color: var(--disabled-label-color);
    `, ({
  error: o
}) => o && e`
      color: var(--negative-label-color);
    `), V = t.div.withConfig({
  displayName: "Element",
  componentId: "sc-1c1mphi-2"
})(["width:100%;height:var(--size-20x);display:flex;flex-direction:column;background-color:transparent;position:relative;padding:var(--spacing-2x);box-sizing:border-box;border:var(--default-border-width) solid var(--elements-border-color);border-radius:var(--default-border-radius);cursor:auto;color:var(--text-placeholder-color);transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&:hover{", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}&:focus-within:not(:active){", " outline-offset:2px;border-color:var(--active-border-color);color:var(--active-placeholder-color);}", " ", " ", ""], S, M, ({
  disabled: o
}) => o && e`
      pointer-events: none;
      border: var(--default-border-width) solid var(--disabled-border-color);
    `, ({
  error: o
}) => o && e`
      border: var(--default-border-width) solid var(--negative-border-color) !important;
    `, ({
  clicked: o
}) => o && e`
      & textarea {
        color: var(--active-placeholder-color);
      }

      border: var(--default-border-width) solid var(--active-border-color);

      transition-property: all;
      transition-timing-function: var(--curve-productive-entrance);
      transition-duration: var(--duration-fast-02);

      &:focus-within:not(:active) {
        outline: transparent;
      }
    `), F = t.textarea.withConfig({
  displayName: "TextArea",
  componentId: "sc-1c1mphi-3"
})(["", " width:100%;height:100%;color:var(--active-placeholder-color);background-color:transparent;outline:none;border:none;cursor:inherit;z-index:1;left:0;resize:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;&:disabled{color:var(--disabled-placeholder-color);&::placeholder{color:var(--disabled-placeholder-color);}}&::placeholder{color:var(--text-placeholder-color);}", ""], $, ({
  error: o
}) => o && e`
      color: var(--negative-placeholder-color) !important;
      width: calc(100% - 32px);

      &::placeholder {
        color: var(--negative-placeholder-color) !important;
      }
    `), O = t.div.withConfig({
  displayName: "Icons",
  componentId: "sc-1c1mphi-4"
})(["position:absolute;right:var(--spacing-2x);top:var(--spacing-2x);z-index:0;display:flex;gap:var(--spacing-1x);", "{color:var(--elements-icon-color);}", ""], m, ({
  error: o
}) => o && e`
      ${m} {
        color: var(--negative-icon-color) !important;
      }
    `), q = t.div.withConfig({
  displayName: "SupportContainer",
  componentId: "sc-1c1mphi-5"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;"]), g = t.p.withConfig({
  displayName: "SupportText",
  componentId: "sc-1c1mphi-6"
})(["", " color:var(--text-support-text-color);", " ", ""], j, ({
  disabled: o
}) => o && e`
      color: var(--disabled-support-text-color);
    `, ({
  error: o
}) => o && e`
      color: var(--negative-support-text-color) !important;
    `), D = T.forwardRef(({
  disabled: o = !1,
  error: r = !1,
  id: l = "",
  value: n = "",
  name: f = "",
  maxLength: p = 100,
  label: x = "",
  placeholder: b = "",
  supportText: d = "",
  showMaxLength: w = !1,
  ...y
}, I) => {
  const [s, v] = c(!1), [C, h] = c(n.length), [k, u] = c(!1);
  return _(() => {
    h(n.length);
  }, [n]), /* @__PURE__ */ i(E, { disabled: o, ref: I, "data-rango-component": "rango-input-text-area", "data-is-rango": !0, ...y, children: [
    /* @__PURE__ */ a(L, { clicked: s || k, disabled: o, error: r && !o, htmlFor: l, children: x }),
    /* @__PURE__ */ i(V, { clicked: s, disabled: o, error: r && !o, onClick: () => {
      v(!0);
    }, children: [
      /* @__PURE__ */ a(F, { id: l, placeholder: b, defaultValue: n, error: r && !o, name: f, maxLength: p, disabled: o, onInput: (N) => {
        const R = N.target.value;
        h(R.length), u(!0);
      }, onBlur: () => {
        v(!1), u(!1);
      } }),
      /* @__PURE__ */ a(O, { error: r && !o, children: r && !o && /* @__PURE__ */ a(B, { icon: "NegativeLine" }) })
    ] }),
    /* @__PURE__ */ i(q, { children: [
      d && /* @__PURE__ */ a(g, { disabled: o, error: r && !o, children: d }),
      w && /* @__PURE__ */ a(g, { disabled: o, error: r && !o, children: (() => `${C}/${p}`)() })
    ] })
  ] });
});
D.displayName = "RangoInputTextArea";
export {
  D as RangoInputTextArea
};
